let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("2wjWj")]).then(() => parcelRequire('k60Oj'));